export interface AcsTab {
  title: string;
  route: string;
  icon: string;
  minAccessLevel: number;
}

export const ACS_TABS: AcsTab[] = [
  { title: 'Bill Address', route: '/admin-config/bill-address', icon: 'fa-address-card', minAccessLevel: 15 },
  { title: 'Delete Customer', route: '/admin-config/delete-customer', icon: 'fa-user-minus', minAccessLevel: 20 },
  { title: 'Elevator Match', route: '/admin-config/elevator-match', icon: 'fa-link', minAccessLevel: 10 },
  { title: 'Trade Unit Default', route: '/admin-config/trade-unit-default', icon: 'fa-sliders', minAccessLevel: 15 },
  { title: 'Location Notes', route: '/admin-config/location-notes', icon: 'fa-sticky-note', minAccessLevel: 10 },
  { title: 'TU & TU Group Mgmt', route: '/admin-config/trade-unit-groups', icon: 'fa-object-group', minAccessLevel: 20 },
  { title: 'User Management', route: '/admin-config/user-management', icon: 'fa-users', minAccessLevel: 20 },
  { title: 'Variable Weight', route: '/admin-config/variable-weight', icon: 'fa-weight-hanging', minAccessLevel: 15 },
  { title: 'Trade Unit Commodities', route: '/admin-config/trade-unit-commodities', icon: 'fa-wheat-awn', minAccessLevel: 15 }
];
